import './LiteralTextInput.css';

import clsx from 'clsx';
import { LiteralTextControl } from '../../../../../types/types';
import { getStyleClassNames } from '../../../../../utils/getStyleClassNames';

interface LiteralTextInputProps {
  control: LiteralTextControl;
}

const LiteralTextInput = ({ control }: LiteralTextInputProps) => {
  const styleClasses = getStyleClassNames(control.style);
  return (
    <div className={clsx('literal-text', styleClasses)}>{control.text}</div>
  );
};

export default LiteralTextInput;
